var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardLeftNoticeIcon2 = function SvgNewcsDashboardLeftNoticeIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_notice_icon2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112 591h12v12h-12z",
    "data-name": "\\u77E9\\u5F62 459"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_left_notice_icon2_svg__a)",
    transform: "translate(-112 -591)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#429289",
    d: "M118 603a6.007 6.007 0 0 1-6-6 6.007 6.007 0 0 1 6-6 6.007 6.007 0 0 1 6 6 6.007 6.007 0 0 1-6 6m0-7.125a.75.75 0 0 0-.75.751v3.5a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.752Zm0-2.75a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75",
    "data-name": "\\u51CF\\u53BB 8"
  }))));
};
export default SvgNewcsDashboardLeftNoticeIcon2;